(function () {
  var overlay = document.getElementById('pt-overlay');
  if (!overlay) return;

  function hide() {
    overlay.classList.add('pt-hidden');
    overlay.classList.remove('pt-visible');
    setTimeout(function () { overlay.style.pointerEvents = 'none'; }, 320);
  }

  function show(cb) {
    overlay.style.pointerEvents = 'all';
    overlay.classList.remove('pt-hidden');
    overlay.classList.add('pt-visible');
    setTimeout(cb, 280);
  }

  // Hide overlay once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hide);
  } else {
    hide();
  }

  // Show overlay on internal link click
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    if (link.target === '_blank') return;
    if (link.hasAttribute('download')) return;
    if (/^(#|mailto:|tel:|javascript:)/.test(href)) return;
    if (link.closest('cart-remove-button')) return;
    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (/^\/cart\/(change|update|add|clear)/.test(url.pathname)) return;
    } catch (err) { return; }

    e.preventDefault();
    show(function () { window.location.href = href; });
  });

  // Handle bfcache (back/forward button)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { hide(); }
  });
})();
